import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants/common';

const initialState = {
  qualifications: {},
  fetchingQualifications: FETCH_STATE.UNSENT,
  fetchedQualificationsSuccess: false,
  fetchedUpdateQualificationSuccess: false,
  errors: {},
};

const qualificationsReducer = createReducer(initialState)({
  // FETCH QUALIFICATIONS
  [types.FETCH_QUALIFICATIONS_REQUEST]: (state, { payload }) => {
    return {
      ...state,
      qualifications: {
        ...state?.qualifications,
        [payload]: {},
      },
      fetchingQualifications: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_QUALIFICATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      qualifications: {
        ...state?.qualifications,
        [payload?.type]: payload?.data?.map((e) => {
          e.requirements = [];
          return e;
        }),
      },
      fetchingQualifications: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_QUALIFICATIONS_FAILED]: (state, { error }) => {
    return {
      ...state,
      qualifications: {},
      errors: error,
      fetchingQualifications: FETCH_STATE.ERROR,
    };
  },

  // FETCH QUALIFICATION BY ID
  [types.FETCH_QUALIFICATION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      qualifications: {
        ...state?.qualifications,
      },
      fetchingQualifications: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_QUALIFICATION_BY_ID_SUCCESS]: (state, { payload }) => {
    const { id, data, type } = payload;
    const qualifications = { ...state.qualifications };
    const index = qualifications[type]?.findIndex((r) => r.id === id);
    if (index > -1) {
      qualifications[type][index] = data;
    }

    return {
      ...state,
      qualifications: { ...qualifications },
      fetchedQualificationsSuccess: true,
      fetchingQualifications: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_QUALIFICATION_BY_ID_FAILED]: (state, { error }) => {
    return {
      ...state,
      errors: error,
      fetchingQualifications: FETCH_STATE.ERROR,
    };
  },

  // FETCH UPDATE QUALIFICATION
  [types.FETCH_UPDATE_QUALIFICATION_REQUEST]: (state) => {
    return {
      ...state,
      qualifications: {
        ...state?.qualifications,
      },
    };
  },
  [types.FETCH_UPDATE_QUALIFICATION_SUCCESS]: (state, { payload }) => {
    const { id, data, type } = payload;
    const qualifications = { ...state.qualifications };
    const index = qualifications[type]?.findIndex((r) => r.id === id);
    if (index > -1) {
      qualifications[type][index] = data;
    }

    return {
      ...state,
      qualifications: { ...qualifications },
      fetchedUpdateQualificationSuccess: true,
    };
  },
  [types.FETCH_UPDATE_QUALIFICATION_FAILED]: (state, { error }) => {
    return {
      ...state,
      errors: error,
    };
  },
});

export default qualificationsReducer;
